<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Basic-Paragraph_para-style-override-6__And__Centre_Alignment"><span><span class="C_span_char-style-override-10">To all the people of Biloxi, past and present,</span></span></p>
<p class="P_Basic-Paragraph_para-style-override-6__And__Centre_Alignment"><span><span class="C_span_char-style-override-10">and to Jane Shambra and Bill Raymond,</span></span></p>
<p class="P_Basic-Paragraph_para-style-override-6__And__Centre_Alignment"><span><span class="C_span_char-style-override-10">who guided me along the way</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?e9733efc